module.exports = __webpack_public_path__ + "img/CHARISMA.e6a0e3eb.png";